(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/team-balance.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/team-balance.js');
'use strict';

const Icon = svs.ui.ReactIcon;
const IconButton = svs.ui.ReactIconButton;
const {
  InfoPairAmount
} = svs.arena.pages.teams.components;
const {
  showPlayableAmountInformationDialog
} = svs.arena.pages.teams.dialogs;
const TeamBalance = _ref => {
  let {
    playableAmount,
    memberBalance
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-top-1"
  }, React.createElement("h3", {
    className: "h3 margin-bottom"
  }, React.createElement(InfoPairAmount, {
    amount: playableAmount,
    isBold: true,
    isColor: true,
    title: "Spelbart saldo i laget"
  }))), React.createElement("div", null, React.createElement("div", {
    className: "col-xs-2"
  }), React.createElement("div", {
    className: "col-xs-8 margin-bottom-2"
  }, React.createElement(InfoPairAmount, {
    amount: memberBalance,
    title: "Mitt eget saldo"
  })), React.createElement("div", {
    className: "col-xs-2 inline-block padding-right-1"
  }, React.createElement(IconButton, {
    "aria-label": "Visa information om spelbart saldo",
    className: "align-self-center",
    onClick: e => showPlayableAmountInformationDialog(e.target),
    size: 300
  }, React.createElement(Icon, {
    icon: "information",
    size: "300"
  })))));
};
svs.arena.pages.teams.components.TeamBalance = TeamBalance;

 })(window);